export const subscriptionApiUrls = {
	getUserSubscription: '/subscriptions/users/:userId',
};

export const subscriptionPrices = {
	price: 800,
	discountPrice: 400,
};
